<template>
  <div id="settings-checklist-dictionary">
    <b-card footer-tag="footer">

      <rc-overlay :show="loading">
        <b-card-text>
          <validation-observer ref="editChecklistDictionaryValidation">
            <form
              id="editChecklistDictionaryForm"
              @submit.prevent
            >

              <b-row>
                <b-col
                  cols="12"
                  class="pb-1"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('conf.settings.checklist-dictionary.value')"
                    rules="required|min:3|max:255"
                  >
                    <label for="checklist-dictionary">
                      {{ $t('conf.settings.checklist-dictionary.value') }}
                    </label>
                    <b-form-input
                      id="checklist-dictionary"
                      v-model="checklistDictionary.value"
                      type="text"
                      minlength="3"
                      maxlength="255"
                      :placeholder="$t('conf.settings.checklist-dictionary.value')"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>

                <b-col
                  cols="12"
                  class="pb-1"
                >
                  <b-form-checkbox
                    v-model="checklistDictionary.active"
                    class="mb-1"
                  >
                    {{ $t('conf.settings.checklist-dictionary.active') }}
                  </b-form-checkbox>
                </b-col>
              </b-row>

            </form>
          </validation-observer>
        </b-card-text>
      </rc-overlay>

      <template #footer>

        <div class="text-right">
          <b-button
            class="mr-1"
            variant="outline-warning"
            @click="$router.back()"
          >
            {{ $t('shared.button.cancel') }}
          </b-button>

          <b-button
            variant="primary"
            :disabled="loading"
            @click="submitForm"
          >
            {{ $t('shared.button.submit') }}
          </b-button>
        </div>

      </template>

    </b-card>
  </div>
</template>

<script>
import { cloneNested, parseRequestError } from '@/helpers/helpers'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RcOverlay from '@/layouts/components/rc/RcOverlay.vue'
import {
  BButton, BCard, BCardText, BCol, BFormCheckbox, BFormInput, BRow,
} from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
    BFormCheckbox,
    BCard,
    BCardText,
    BButton,
    RcOverlay,
    BRow,
    BCol,

    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    checklistDictionary() {
      return cloneNested(this.$store.getters['settings/getChecklistDictionaryData'])
    },
  },
  created() {
    this.initChecklistDictionaryData()
  },
  beforeDestroy() {
    this.$store.commit('settings/CLEAR_CHECKLIST_DICTIONARY_DATA')
  },
  methods: {
    initChecklistDictionaryData() {
      this.loading = true
      this.$store.dispatch('settings/fetchChecklistDictionaryData', this.$route.params.id)
        .then(() => {
          this.loading = false
        })
        .catch(err => parseRequestError(err))
    },
    submitForm() {
      this.$refs.editChecklistDictionaryValidation.validate()
        .then(valid => {
          if (!valid) {
            return false
          }

          this.loading = true
          const checklistDictionaryData = cloneNested(this.checklistDictionary)

          const payload = {
            id: checklistDictionaryData.id,
            data: checklistDictionaryData,
          }
          this.$store.dispatch('settings/updateChecklistDictionary', payload)
            .then(() => {
              window.toast.notify.success(this.$t('conf.settings.checklist-dictionary.notify.edit.success_title'))
            })
            .catch(err => {
              parseRequestError(err)
              this.initChecklistDictionaryData()
            })
            .finally(() => {
              this.loading = false
            })

          return true
        })
    },
  },
}
</script>
